import { Directive, Input, OnChanges, forwardRef } from '@angular/core';
import {
  NG_VALIDATORS,
  AbstractControl,
  ValidationErrors,
  Validators,
  ValidatorFn
} from '@angular/forms';

@Directive({
  selector: '[abMinLengthTrim][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MinLengthTrimDirective),
      multi: true
    }
  ]
})
export class MinLengthTrimDirective implements Validators, OnChanges {
  @Input() abMinLengthTrim: number;

  private valFun: ValidatorFn;

  constructor() {}

  ngOnChanges() {
    this.valFun = Validators.minLength(this.abMinLengthTrim);
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.valFun(
      control.value
        ? ({ value: control.value.trim() } as AbstractControl)
        : control
    );
  }
}
